<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-User",
  path: "user",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
